export const selectFilter = (state) => state.filter